export const users = [
    { username: "admin", password: "1234" },
    { username: "user", password: "abcd" },
    { username: "gusthavo", password: "gusthavo123"}
];